import { gql } from 'apollo-angular';

export const REPORT_TRANSACTION_EXPRESS = gql`
  query expressTransactionReport {
    expressTransactionReport {
      message
    }
  }
`;

export const REPORT_TRANSACTION_OKRIDE = gql`
  query okRideTransactionReport {
    okRideTransactionReport {
      message
    }
  }
`;

export const REPORT_TRANSACTION_MOTOTAXI = gql`
  query motoTaxiTransactionReport {
    motoTaxiTransactionReport {
      message
    }
  }
`;

export const PARTNERS_DOWNLOAD_REPORT_V1 = gql`
  query partnersDownloadReportV1 {
    partnersDownloadReportV1 {
      message
    }
  }
`;

export const PARTNERS_DOWNLOAD_REPORT_V2 = gql`
  query partnersDownloadReportV2 {
    partnersDownloadReportV2 {
      message
    }
  }
`;

export const USERS_DOWNLOAD_REPORT = gql`
  query UsersReport {
    usersReport {
      message
    }
  }
`;

